module.exports=[
  { "country": "Argentina", "name": "Buenos Aires", "value": "1" },
  { "country": "Argentina", "name": "Capital Federal", "value": "0" },
  { "country": "Argentina", "name": "Catamarca", "value": "2" },
  { "country": "Argentina", "name": "Chaco", "value": "16" },
  { "country": "Argentina", "name": "Chubut", "value": "17" },
  { "country": "Argentina", "name": "Córdoba", "value": "3" },
  { "country": "Argentina", "name": "Corrientes", "value": "4" },
  { "country": "Argentina", "name": "Entre Rios", "value": "5" },
  { "country": "Argentina", "name": "Formosa", "value": "18" },
  { "country": "Argentina", "name": "Jujuy", "value": "6" },
  { "country": "Argentina", "name": "La Pampa", "value": "21" },
  { "country": "Argentina", "name": "La Rioja", "value": "8" },
  { "country": "Argentina", "name": "Mendoza", "value": "7" },
  { "country": "Argentina", "name": "Misiones", "value": "19" },
  { "country": "Argentina", "name": "Neuquen", "value": "20" },
  { "country": "Argentina", "name": "Rio Negro", "value": "22" },
  { "country": "Argentina", "name": "Salta", "value": "9" },
  { "country": "Argentina", "name": "San Juan", "value": "10" },
  { "country": "Argentina", "name": "San Luis", "value": "11" },
  { "country": "Argentina", "name": "Santa Cruz", "value": "23" },
  { "country": "Argentina", "name": "Santa Fe", "value": "12" },
  { "country": "Argentina", "name": "Santiago Del Estero", "value": "13" },
  { "country": "Argentina", "name": "Tierra De Fuego", "value": "24" },
  { "country": "Argentina", "name": "Tucuman", "value": "14" },
  { "country": "Australia", "name": "Aust Capital Terr", "value": "ACT" },
  { "country": "Australia", "name": "New South Wales", "value": "NSW" },
  { "country": "Australia", "name": "Northern Territory", "value": "NT" },
  { "country": "Australia", "name": "Queensland", "value": "QLD" },
  { "country": "Australia", "name": "South Australia", "value": "SA" },
  { "country": "Australia", "name": "Tasmania", "value": "TAS" },
  { "country": "Australia", "name": "Victoria", "value": "VIC" },
  { "country": "Australia", "name": "Western Australia", "value": "WA" },
  { "country": "Brazil", "name": "Acre", "value": "AC" },
  { "country": "Brazil", "name": "Alagoas", "value": "AL" },
  { "country": "Brazil", "name": "Amapa", "value": "AP" },
  { "country": "Brazil", "name": "Amazonas", "value": "AM" },
  { "country": "Brazil", "name": "Bahia", "value": "BA" },
  { "country": "Brazil", "name": "Brasilia", "value": "DF" },
  { "country": "Brazil", "name": "Ceara", "value": "CE" },
  { "country": "Brazil", "name": "Espirito Santo", "value": "ES" },
  { "country": "Brazil", "name": "Goias", "value": "GO" },
  { "country": "Brazil", "name": "Maranhão", "value": "MA" },
  { "country": "Brazil", "name": "Mato Grosso", "value": "MT" },
  { "country": "Brazil", "name": "Mato Grosso Do Sul", "value": "MS" },
  { "country": "Brazil", "name": "Minas Gerais", "value": "MG" },
  { "country": "Brazil", "name": "Para", "value": "PA" },
  { "country": "Brazil", "name": "Paraiba", "value": "PB" },
  { "country": "Brazil", "name": "Parana", "value": "PR" },
  { "country": "Brazil", "name": "Pernambuco", "value": "PE" },
  { "country": "Brazil", "name": "Piaui", "value": "PI" },
  { "country": "Brazil", "name": "Rio De Janeiro", "value": "RJ" },
  { "country": "Brazil", "name": "Rio Grande Do Norte", "value": "RN" },
  { "country": "Brazil", "name": "Rio Grande Do Sul", "value": "RS" },
  { "country": "Brazil", "name": "Rondonia", "value": "RO" },
  { "country": "Brazil", "name": "Roraima", "value": "RR" },
  { "country": "Brazil", "name": "Santa Catarina", "value": "SC" },
  { "country": "Brazil", "name": "São Paulo", "value": "SP" },
  { "country": "Brazil", "name": "Sergipe", "value": "SE" },
  { "country": "Brazil", "name": "Tocantins", "value": "TO" },
  { "country": "Canada", "name": "Alberta", "value": "AB" },
  { "country": "Canada", "name": "British Columbia", "value": "BC" },
  { "country": "Canada", "name": "Manitoba", "value": "MB" },
  { "country": "Canada", "name": "New Brunswick", "value": "NB" },
  { "country": "Canada", "name": "Newfoundland", "value": "NF" },
  { "country": "Canada", "name": "Northwest Territory", "value": "NT" },
  { "country": "Canada", "name": "Nova Scotia", "value": "NS" },
  { "country": "Canada", "name": "Ontario", "value": "ON" },
  { "country": "Canada", "name": "Outside Province/Can", "value": "ZZ" },
  { "country": "Canada", "name": "Prince Edward Island", "value": "PE" },
  { "country": "Canada", "name": "Quebec", "value": "QC" },
  { "country": "Canada", "name": "Saskatchewan", "value": "SK" },
  { "country": "Canada", "name": "Yukon", "value": "YT" },
  { "country": "China", "name": "Anhui", "value": "110" },
  { "country": "China", "name": "Beijing", "value": "10" },
  { "country": "China", "name": "Chongqing", "value": "320" },
  { "country": "China", "name": "Fujian", "value": "150" },
  { "country": "China", "name": "Gansu", "value": "260" },
  { "country": "China", "name": "Guangdong", "value": "190" },
  { "country": "China", "name": "Guangxi", "value": "210" },
  { "country": "China", "name": "Guizhou", "value": "220" },
  { "country": "China", "name": "Hainan", "value": "200" },
  { "country": "China", "name": "Hebei", "value": "60" },
  { "country": "China", "name": "Heilongjiang", "value": "90" },
  { "country": "China", "name": "Henan", "value": "180" },
  { "country": "China", "name": "Hubei", "value": "170" },
  { "country": "China", "name": "Hunan", "value": "160" },
  { "country": "China", "name": "Jiangsu", "value": "100" },
  { "country": "China", "name": "Jiangxi", "value": "140" },
  { "country": "China", "name": "Jilin", "value": "80" },
  { "country": "China", "name": "Liaoning", "value": "70" },
  { "country": "China", "name": "Ningxia", "value": "270" },
  { "country": "China", "name": "Qinghai", "value": "280" },
  { "country": "China", "name": "Shaanxi", "value": "250" },
  { "country": "China", "name": "Shandong", "value": "120" },
  { "country": "China", "name": "Shanghai", "value": "20" },
  { "country": "China", "name": "Shanxi", "value": "50" },
  { "country": "China", "name": "Sichuan", "value": "230" },
  { "country": "China", "name": "Tianjin", "value": "30" },
  { "country": "China", "name": "Xinjiang", "value": "290" },
  { "country": "China", "name": "Xizang", "value": "300" },
  { "country": "China", "name": "Yunnan", "value": "240" },
  { "country": "China", "name": "Zhejiang", "value": "130" },
  { "country": "India", "name": "Andaman And Nicobar Islands", "value": "26" },
  { "country": "India", "name": "Andhra Pradesh", "value": "1" },
  { "country": "India", "name": "Arunachal Pradesh", "value": "2" },
  { "country": "India", "name": "Assam", "value": "3" },
  { "country": "India", "name": "Bihar", "value": "4" },
  { "country": "India", "name": "Chandigarh", "value": "27" },
  { "country": "India", "name": "Chhattisgarh", "value": "36" },
  {
    "country": "India",
    "name": "Dadra And Nagar Haveli And Daman And Diu",
    "value": "28"
  },
  { "country": "India", "name": "Delhi", "value": "30" },
  { "country": "India", "name": "Goa", "value": "5" },
  { "country": "India", "name": "Gujarat", "value": "6" },
  { "country": "India", "name": "Haryana", "value": "7" },
  { "country": "India", "name": "Himachal Pradesh", "value": "8" },
  { "country": "India", "name": "Jammu And Kashmir", "value": "9" },
  { "country": "India", "name": "Jharkhand", "value": "33" },
  { "country": "India", "name": "Karnataka", "value": "10" },
  { "country": "India", "name": "Kerala", "value": "11" },
  { "country": "India", "name": "Lakshadweep", "value": "31" },
  { "country": "India", "name": "Madhya Pradesh", "value": "12" },
  { "country": "India", "name": "Maharashtra", "value": "13" },
  { "country": "India", "name": "Manipur", "value": "14" },
  { "country": "India", "name": "Meghalaya", "value": "15" },
  { "country": "India", "name": "Mizoram", "value": "16" },
  { "country": "India", "name": "Nagaland", "value": "17" },
  { "country": "India", "name": "Odisha ", "value": "18" },
  { "country": "India", "name": "Puducherry", "value": "32" },
  { "country": "India", "name": "Punjab", "value": "19" },
  { "country": "India", "name": "Rajasthan", "value": "20" },
  { "country": "India", "name": "Sikkim", "value": "21" },
  { "country": "India", "name": "Tamil Nadu", "value": "22" },
  { "country": "India", "name": "Tripura", "value": "23" },
  { "country": "India", "name": "Uttar Pradesh", "value": "24" },
  { "country": "India", "name": "Uttarakhand", "value": "34" },
  { "country": "India", "name": "West Bengal", "value": "25" },
  { "country": "Malaysia", "name": "Johor", "value": "JOH" },
  { "country": "Malaysia", "name": "Kedah", "value": "KED" },
  { "country": "Malaysia", "name": "Kelantan", "value": "KEL" },
  { "country": "Malaysia", "name": "Kuala Lumpur", "value": "KUL" },
  { "country": "Malaysia", "name": "Labuan", "value": "LAB" },
  { "country": "Malaysia", "name": "Melaka", "value": "MEL" },
  { "country": "Malaysia", "name": "Negeri Sembilan", "value": "SER" },
  { "country": "Malaysia", "name": "Pahang", "value": "PAH" },
  { "country": "Malaysia", "name": "Perak", "value": "PER" },
  { "country": "Malaysia", "name": "Perlis", "value": "PEL" },
  { "country": "Malaysia", "name": "Putrajaya", "value": "PJY" },
  { "country": "Malaysia", "name": "Sabah", "value": "SAB" },
  { "country": "Malaysia", "name": "Sarawak", "value": "SAR" },
  { "country": "Malaysia", "name": "Selangor", "value": "SEL" },
  { "country": "Malaysia", "name": "Terengganu", "value": "TRE" },
  { "country": "Mexico", "name": "Aguascalientes", "value": "AGS" },
  { "country": "Mexico", "name": "Baja California", "value": "BC" },
  { "country": "Mexico", "name": "Baja California N", "value": "BCN" },
  { "country": "Mexico", "name": "Baja California S", "value": "BCS" },
  { "country": "Mexico", "name": "Campeche", "value": "CMP" },
  { "country": "Mexico", "name": "Chiapas", "value": "CHS" },
  { "country": "Mexico", "name": "Chihuahua", "value": "CHI" },
  { "country": "Mexico", "name": "Coahuila", "value": "COA" },
  { "country": "Mexico", "name": "Colima", "value": "COL" },
  { "country": "Mexico", "name": "Distrito Federal", "value": "DF" },
  { "country": "Mexico", "name": "Durango", "value": "DGO" },
  { "country": "Mexico", "name": "Estado De Mexico", "value": "MEX" },
  { "country": "Mexico", "name": "Guanajuato", "value": "GTO" },
  { "country": "Mexico", "name": "Guerrero", "value": "GRO" },
  { "country": "Mexico", "name": "Hidalgo", "value": "HGO" },
  { "country": "Mexico", "name": "Jalisco", "value": "JAL" },
  { "country": "Mexico", "name": "Michoacan", "value": "MCH" },
  { "country": "Mexico", "name": "Morelos", "value": "MOR" },
  { "country": "Mexico", "name": "Nayarit", "value": "NAY" },
  { "country": "Mexico", "name": "Nuevo Leon", "value": "NL" },
  { "country": "Mexico", "name": "Oaxaca", "value": "OAX" },
  { "country": "Mexico", "name": "Puebla", "value": "PUE" },
  { "country": "Mexico", "name": "Queretaro", "value": "QRO" },
  { "country": "Mexico", "name": "Quintana Roo", "value": "QR" },
  { "country": "Mexico", "name": "San Luis Potosi", "value": "SLP" },
  { "country": "Mexico", "name": "Sinaloa", "value": "SIN" },
  { "country": "Mexico", "name": "Sonora", "value": "SON" },
  { "country": "Mexico", "name": "Tabasco", "value": "TAB" },
  { "country": "Mexico", "name": "Tamaulipas", "value": "TMS" },
  { "country": "Mexico", "name": "Tlaxcala", "value": "TLX" },
  { "country": "Mexico", "name": "Veracruz", "value": "VER" },
  { "country": "Mexico", "name": "Yucatan", "value": "YUC" },
  { "country": "Mexico", "name": "Zacatecas", "value": "ZAC" },
  {
    "country": "Pakistan",
    "name": "Azad Kashmir",
    "value": "Azad Jammu & Kashmir"
  },
  { "country": "Pakistan", "name": "Balochistan", "value": "Balochistan" },
  {
    "country": "Pakistan",
    "name": "Gilgit-Baltistan",
    "value": "Gilgit-Baltistan"
  },
  {
    "country": "Pakistan",
    "name": "Islamabad Capital Territory",
    "value": "Islamabad Capital Territory"
  },
  {
    "country": "Pakistan",
    "name": "Khyber Pakhtunkhwa",
    "value": "Khyber Pakhtunkhwa"
  },
  { "country": "Pakistan", "name": "Punjab", "value": "19" },
  { "country": "Pakistan", "name": "Sindh", "value": "Sindh" },
  {
    "country": "Russian Federation",
    "name": "Adygea, Republic Of",
    "value": "1"
  },
  { "country": "Russian Federation", "name": "Altai Krai", "value": "22" },
  { "country": "Russian Federation", "name": "Altai Republic", "value": "2" },
  { "country": "Russian Federation", "name": "Amur Oblast", "value": "28" },
  {
    "country": "Russian Federation",
    "name": "Arkhangelsk Oblast",
    "value": "29"
  },
  {
    "country": "Russian Federation",
    "name": "Astrakhan Oblast",
    "value": "30"
  },
  {
    "country": "Russian Federation",
    "name": "Bashkortostan, Republic Of",
    "value": "3"
  },
  { "country": "Russian Federation", "name": "Belgorod Oblast", "value": "31" },
  { "country": "Russian Federation", "name": "Bryansk Oblast", "value": "32" },
  {
    "country": "Russian Federation",
    "name": "Buryatia, Republic Of",
    "value": "4"
  },
  {
    "country": "Russian Federation",
    "name": "Chechen Republic",
    "value": "20"
  },
  {
    "country": "Russian Federation",
    "name": "Chelyabinsk Oblast",
    "value": "74"
  },
  {
    "country": "Russian Federation",
    "name": "Chukotka Autonomous Okrug",
    "value": "87"
  },
  {
    "country": "Russian Federation",
    "name": "Chuvash Republic",
    "value": "21"
  },
  {
    "country": "Russian Federation",
    "name": "Dagestan, Republic Of",
    "value": "5"
  },
  {
    "country": "Russian Federation",
    "name": "Ingushetia, Republic Of",
    "value": "6"
  },
  { "country": "Russian Federation", "name": "Irkutsk Oblast", "value": "38" },
  { "country": "Russian Federation", "name": "Ivanovo Oblast", "value": "37" },
  {
    "country": "Russian Federation",
    "name": "Jewish Autonomous Oblast",
    "value": "79"
  },
  {
    "country": "Russian Federation",
    "name": "Kabardino-Balkar Republic",
    "value": "7"
  },
  {
    "country": "Russian Federation",
    "name": "Kaliningrad Oblast",
    "value": "39"
  },
  {
    "country": "Russian Federation",
    "name": "Kalmykia, Republic Of",
    "value": "8"
  },
  { "country": "Russian Federation", "name": "Kaluga Oblast", "value": "40" },
  { "country": "Russian Federation", "name": "Kamchatka Krai", "value": "41" },
  {
    "country": "Russian Federation",
    "name": "Karachay-Cherkess Republic",
    "value": "9"
  },
  {
    "country": "Russian Federation",
    "name": "Karelia, Republic Of",
    "value": "10"
  },
  { "country": "Russian Federation", "name": "Kemerovo Oblast", "value": "42" },
  { "country": "Russian Federation", "name": "Khabarovsk Krai", "value": "27" },
  {
    "country": "Russian Federation",
    "name": "Khakassia, Republic Of",
    "value": "Khakassia, Republic Of"
  },
  {
    "country": "Russian Federation",
    "name": "Khanty–Mansi Autonomous Okrug – Yugra",
    "value": "Khanty-Mansi Autonomous Okrug-Yugra"
  },
  { "country": "Russian Federation", "name": "Kirov Oblast", "value": "43" },
  { "country": "Russian Federation", "name": "Komi Republic", "value": "11" },
  { "country": "Russian Federation", "name": "Kostroma Oblast", "value": "44" },
  { "country": "Russian Federation", "name": "Krasnodar Krai", "value": "23" },
  {
    "country": "Russian Federation",
    "name": "Krasnoyarsk Krai",
    "value": "24"
  },
  { "country": "Russian Federation", "name": "Kurgan Oblast", "value": "45" },
  { "country": "Russian Federation", "name": "Kursk Oblast", "value": "46" },
  {
    "country": "Russian Federation",
    "name": "Leningrad Oblast",
    "value": "47"
  },
  { "country": "Russian Federation", "name": "Lipetsk Oblast", "value": "48" },
  { "country": "Russian Federation", "name": "Magadan Oblast", "value": "49" },
  {
    "country": "Russian Federation",
    "name": "Mari El Republic",
    "value": "Mari El Republic"
  },
  {
    "country": "Russian Federation",
    "name": "Mordovia, Republic Of",
    "value": "13"
  },
  { "country": "Russian Federation", "name": "Moscow", "value": "77" },
  { "country": "Russian Federation", "name": "Moscow Oblast", "value": "50" },
  { "country": "Russian Federation", "name": "Murmansk Oblast", "value": "51" },
  {
    "country": "Russian Federation",
    "name": "Nenets Autonomous Okrug",
    "value": "Nenets Autonomous Okrug"
  },
  {
    "country": "Russian Federation",
    "name": "Nizhny Novgorod Oblast",
    "value": "52"
  },
  {
    "country": "Russian Federation",
    "name": "North Ossetia-Alania, Republic Of",
    "value": "15"
  },
  { "country": "Russian Federation", "name": "Novgorod Oblast", "value": "53" },
  {
    "country": "Russian Federation",
    "name": "Novosibirsk Oblast",
    "value": "54"
  },
  { "country": "Russian Federation", "name": "Omsk Oblast", "value": "55" },
  { "country": "Russian Federation", "name": "Orenburg Oblast", "value": "56" },
  { "country": "Russian Federation", "name": "Oryol Oblast", "value": "57" },
  { "country": "Russian Federation", "name": "Penza Oblast", "value": "58" },
  { "country": "Russian Federation", "name": "Perm Krai", "value": "59" },
  { "country": "Russian Federation", "name": "Primorsky Krai", "value": "25" },
  { "country": "Russian Federation", "name": "Pskov Oblast", "value": "60" },
  {
    "country": "Russian Federation",
    "name": "Republic Of Crimea",
    "value": "Republic Of Crimea"
  },
  { "country": "Russian Federation", "name": "Rostov Oblast", "value": "61" },
  { "country": "Russian Federation", "name": "Ryazan Oblast", "value": "62" },
  {
    "country": "Russian Federation",
    "name": "Saint Petersburg",
    "value": "78"
  },
  {
    "country": "Russian Federation",
    "name": "Sakha (Yakutia) Republic",
    "value": "Sakha (Yakutia) Republic"
  },
  { "country": "Russian Federation", "name": "Sakhalin Oblast", "value": "65" },
  { "country": "Russian Federation", "name": "Samara Oblast", "value": "63" },
  { "country": "Russian Federation", "name": "Saratov Oblast", "value": "64" },
  {
    "country": "Russian Federation",
    "name": "Sevastopol",
    "value": "Sevastopol"
  },
  { "country": "Russian Federation", "name": "Smolensk Oblast", "value": "67" },
  { "country": "Russian Federation", "name": "Stavropol Krai", "value": "26" },
  {
    "country": "Russian Federation",
    "name": "Sverdlovsk Oblast",
    "value": "66"
  },
  { "country": "Russian Federation", "name": "Tambov Oblast", "value": "68" },
  {
    "country": "Russian Federation",
    "name": "Tatarstan, Republic Of",
    "value": "16"
  },
  { "country": "Russian Federation", "name": "Tomsk Oblast", "value": "70" },
  { "country": "Russian Federation", "name": "Tula Oblast", "value": "71" },
  { "country": "Russian Federation", "name": "Tuva Republic", "value": "17" },
  { "country": "Russian Federation", "name": "Tver Oblast", "value": "69" },
  { "country": "Russian Federation", "name": "Tyumen Oblast", "value": "72" },
  { "country": "Russian Federation", "name": "Udmurt Republic", "value": "18" },
  {
    "country": "Russian Federation",
    "name": "Ulyanovsk Oblast",
    "value": "73"
  },
  { "country": "Russian Federation", "name": "Vladimir Oblast", "value": "33" },
  {
    "country": "Russian Federation",
    "name": "Volgograd Oblast",
    "value": "34"
  },
  { "country": "Russian Federation", "name": "Vologda Oblast", "value": "35" },
  { "country": "Russian Federation", "name": "Voronezh Oblast", "value": "36" },
  {
    "country": "Russian Federation",
    "name": "Yamalo-Nenets Autonomous Okrug",
    "value": "Yamalo-Nenets Autonomous Okrug"
  },
  {
    "country": "Russian Federation",
    "name": "Yaroslavl Oblast",
    "value": "76"
  },
  {
    "country": "Russian Federation",
    "name": "Zabaykalsky Krai",
    "value": "Zabaykalsky Krai"
  },
  { "country": "United States", "name": "Alabama", "value": "AL" },
  { "country": "United States", "name": "Alaska", "value": "AK" },
  { "country": "United States", "name": "Arizona", "value": "AZ" },
  { "country": "United States", "name": "Arkansas", "value": "AR" },
  { "country": "United States", "name": "California", "value": "CA" },
  { "country": "United States", "name": "Colorado", "value": "CO" },
  { "country": "United States", "name": "Connecticut", "value": "CT" },
  { "country": "United States", "name": "Delaware", "value": "DE" },
  { "country": "United States", "name": "District Of Columbia", "value": "DC" },
  { "country": "United States", "name": "Florida", "value": "FL" },
  { "country": "United States", "name": "Georgia", "value": "GA" },
  { "country": "United States", "name": "Hawaii", "value": "HI" },
  { "country": "United States", "name": "Idaho", "value": "ID" },
  { "country": "United States", "name": "Illinois", "value": "IL" },
  { "country": "United States", "name": "Indiana", "value": "IN" },
  { "country": "United States", "name": "Iowa", "value": "IA" },
  { "country": "United States", "name": "Kansas", "value": "KS" },
  { "country": "United States", "name": "Kentucky", "value": "KY" },
  { "country": "United States", "name": "Louisiana", "value": "LA" },
  { "country": "United States", "name": "Maine", "value": "ME" },
  { "country": "United States", "name": "Maryland", "value": "MD" },
  { "country": "United States", "name": "Massachusetts", "value": "MA" },
  { "country": "United States", "name": "Michigan", "value": "MI" },
  { "country": "United States", "name": "Minnesota", "value": "MN" },
  { "country": "United States", "name": "Mississippi", "value": "MS" },
  { "country": "United States", "name": "Missouri", "value": "MO" },
  { "country": "United States", "name": "Montana", "value": "MT" },
  { "country": "United States", "name": "Nebraska", "value": "NE" },
  { "country": "United States", "name": "Nevada", "value": "NV" },
  { "country": "United States", "name": "New Hampshire", "value": "NH" },
  { "country": "United States", "name": "New Jersey", "value": "NJ" },
  { "country": "United States", "name": "New Mexico", "value": "NM" },
  { "country": "United States", "name": "New York", "value": "NY" },
  { "country": "United States", "name": "North Carolina", "value": "NC" },
  { "country": "United States", "name": "North Dakota", "value": "ND" },
  { "country": "United States", "name": "Ohio", "value": "OH" },
  { "country": "United States", "name": "Oklahoma", "value": "OK" },
  { "country": "United States", "name": "Oregon", "value": "OR" },
  { "country": "United States", "name": "Pennsylvania", "value": "PA" },
  { "country": "United States", "name": "Puerto Rico", "value": "PR" },
  { "country": "United States", "name": "Rhode Island", "value": "RI" },
  { "country": "United States", "name": "South Carolina", "value": "SC" },
  { "country": "United States", "name": "South Dakota", "value": "SD" },
  { "country": "United States", "name": "Tennessee", "value": "TN" },
  { "country": "United States", "name": "Texas", "value": "TX" },
  { "country": "United States", "name": "Utah", "value": "UT" },
  { "country": "United States", "name": "Vermont", "value": "VT" },
  { "country": "United States", "name": "Virginia", "value": "VA" },
  { "country": "United States", "name": "Washington", "value": "WA" },
  { "country": "United States", "name": "West Virginia", "value": "WV" },
  { "country": "United States", "name": "Wisconsin", "value": "WI" },
  { "country": "United States", "name": "Wyoming", "value": "WY" },
  { "country": "Venezuela", "name": "Amazonas", "value": "AMA" },
  { "country": "Venezuela", "name": "Anzoategui", "value": "ANZ" },
  { "country": "Venezuela", "name": "Apure", "value": "APU" },
  { "country": "Venezuela", "name": "Aragua", "value": "ARA" },
  { "country": "Venezuela", "name": "Barinas", "value": "BAR" },
  { "country": "Venezuela", "name": "Bolivar", "value": "BOL" },
  { "country": "Venezuela", "name": "Carabobo", "value": "CAR" },
  { "country": "Venezuela", "name": "Cojedes", "value": "COJ" },
  { "country": "Venezuela", "name": "Delta Amacuro", "value": "DA" },
  { "country": "Venezuela", "name": "Distrito Federa", "value": "DC" },
  { "country": "Venezuela", "name": "Falcon", "value": "FAL" },
  { "country": "Venezuela", "name": "Guarico", "value": "GUA" },
  { "country": "Venezuela", "name": "Lara", "value": "LAR" },
  { "country": "Venezuela", "name": "Merida", "value": "MER" },
  { "country": "Venezuela", "name": "Miranda", "value": "MIR" },
  { "country": "Venezuela", "name": "Monagas", "value": "MON" },
  { "country": "Venezuela", "name": "Nueva Esparta", "value": "NE" },
  { "country": "Venezuela", "name": "Portuguesa", "value": "POR" },
  { "country": "Venezuela", "name": "Sucre", "value": "SUC" },
  { "country": "Venezuela", "name": "Tachira", "value": "TAC" },
  { "country": "Venezuela", "name": "Trujillo", "value": "TRU" },
  { "country": "Venezuela", "name": "Vargas", "value": "VAR" },
  { "country": "Venezuela", "name": "Yaracuy", "value": "YAR" },
  { "country": "Venezuela", "name": "Zulia", "value": "ZUL" }
]
